
<div class="p-toast-message-text">
    <div class="flex flex-row gap-2">
        <span class="p-toast-message-icon" aria-hidden="true">
            <i class="pi pi-{{ message().data?.icon ?? 'info-circle'}} text-xl"></i>
        </span>        
        <div class="p-toast-summary">{{message().data?.problem.errorCode}}</div>
    </div>
    <div class="p-toast-detail">{{message().data?.problem.detail}}</div>
    <div class="opacity-90 flex flex-row justify-between w-full mt-1">
        <label class="text-xs">Operation Id</label>
        <small class="text-xs">{{message().data?.problem.operationId}}</small>
    </div>
</div>